@if (title || isHeaderShown) {
  <ng-content select="modal-header-actions"></ng-content>
  <ng-content></ng-content>
  @if (title) {
    <div
      class="modal-header-title"
      [attr.e2e-attr]="E2E_ATTRIBUTES.MODAL_HEADER_TITLE"
    >
      {{ title }}
    </div>
  }
  <ng-content select="modal-header-dropdown"></ng-content>
  <ng-content select="modal-header-alt-actions"></ng-content>
}
